<template>
  <div class="home">
    <Hero :title="data?.hero?.title" :description="data?.hero?.description">
      <template #image>
        <ElementsImage v-if="data?.hero?.image" v-bind="data.hero.image" />
      </template>
    </Hero>

    <ElementsContainer>
      <ElementsInfo v-if="data?.info" v-bind="data.info" />
      <HomeRooms />
    </ElementsContainer>

    <HomeExplore />

    <ElementsContainer>
      <HomeEvents />
    </ElementsContainer>

    <Social />

    <ElementsContainer>
      <Comments />
    </ElementsContainer>
  </div>
</template>

<script setup lang="ts">
  import fetchApi from "~/utils/fetchApi"

  const { data: responseData } = await useAsyncData("home", () =>
    fetchApi<any>("home", {
      wrappedByKey: "data",
      populate: {
        hero: { populate: "*" },
        info: { populate: "*" }
      }
    })
  )

  const data = computed(() => responseData.value || {})

  const { t } = useI18n()

  useSeoMeta({
    title: () => data.value?.hero?.title || t("menu.zimmerHotels"),
    description: () => data.value?.hero?.description || ""
  })
</script>
